import { apiClient } from "../../../base/ApiClient";


export const createAssessmentForm = async (data) => {
  const res = await apiClient.post("/assessments/forms/", data);
  return res.data;
};

export const getAssessmentForms = async (params = {}) => {
  const res = await apiClient.get(`/assessments/all/`, { params });
  return res.data;
};

export const getAssessmentFormByID = async (formId) => {
  const res = await apiClient.get(`/assessments/forms/${formId}/`);
  return res.data;
};

export const updateAssessmentForm = async (id, payload) => {
  const res = await apiClient.patch(`/assessments/forms/${id}/`, payload);
  return res.data;
};